export const environment = {
  production: false,
  API: 'https://lea.bco.proxy.eveasoft.com/module/fam/api/',
  //API: 'https://srv.bco.eveasoft.com/php/api/api.php', //Accès direct au serveur (avant)
  //server: 'srv.bco.eveasoft.com', // Sert pour la white list
  server: 'lea.bco.proxy.eveasoft.com',
  date: '', // Permet de voir quelle version est déployée (à remplacer lors du déploiement)
  // version: '1.0.2',
};
